import { render, staticRenderFns } from "./AuctionItems.vue?vue&type=template&id=85110062&scoped=true"
import script from "./AuctionItems.vue?vue&type=script&lang=js"
export * from "./AuctionItems.vue?vue&type=script&lang=js"
import style0 from "./AuctionItems.vue?vue&type=style&index=0&id=85110062&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85110062",
  null
  
)

export default component.exports